type CategoryGameIdsSource = {
  _id?: string;
  id?: string;
  gameIds?: string[];
};

export const createSelectedGameIdSet = (gameIds?: string[]) => new Set(gameIds ?? []);

export const createSelectedGamePositionMap = (selectedGameIds: ReadonlySet<string>) => {
  return new Map(Array.from(selectedGameIds).map((gameId, index) => [gameId, index + 1]));
};

export const getCategoryGameIds = (
  category: CategoryGameIdsSource,
  categories: CategoryGameIdsSource[] = []
): string[] | undefined => {
  const fetchedCategory = categories.find(({ _id, id }) => _id === category.id || id === category.id);

  return fetchedCategory?.gameIds ?? category.gameIds;
};

export const toggleSelectedGameId = (selectedGameIds: ReadonlySet<string>, gameId: string) => {
  const nextSelectedGameIds = new Set(selectedGameIds);

  if (nextSelectedGameIds.has(gameId)) {
    nextSelectedGameIds.delete(gameId);
    return nextSelectedGameIds;
  }

  nextSelectedGameIds.add(gameId);
  return nextSelectedGameIds;
};

export const reorderSelectedGameIds = (
  selectedGameIds: ReadonlySet<string>,
  gameId: string,
  position: number | null
) => {
  const orderedIds = Array.from(selectedGameIds).filter((selectedGameId) => selectedGameId !== gameId);

  if (position === null) {
    return new Set(orderedIds);
  }

  const nextIndex = Math.max(0, Math.min(position - 1, orderedIds.length));
  orderedIds.splice(nextIndex, 0, gameId);

  return new Set(orderedIds);
};
